module.exports = __webpack_public_path__ + "static/img/customs_banner_pc_in.9b7448e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customs_banner_pc_in.png
// module id = x0gz
// module chunks = 1